
export class CommonRouteConstants {
    public static readonly SetInitialPassword = "/account/set-password";
    public static readonly PersonalDashboard = "/people/dashboard";
    public static readonly ActivityDashboard = "/people/activity";
    public static readonly OrganisationDashboard = "/dashboard";
}
